/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharedplan_IntroInputs */

const en_us2_sharedplan_intro = /** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing changes in your plan until you review it. Importing opens the line-by-line review, where you accept or decline each exercise.`)
};

const pt_br2_sharedplan_intro = /** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda no seu plano até você revisar. Importar abre a revisão linha a linha, onde você aceita ou recusa cada exercício.`)
};

const pt_pt2_sharedplan_intro = /** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada muda no seu plano até você revisar. Importar abre a revisão linha a linha, onde você aceita ou recusa cada exercício.`)
};

/** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */
const es_419_sharedplan_intro = en_us2_sharedplan_intro;

/** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */
const fr_fr2_sharedplan_intro = en_us2_sharedplan_intro;

/** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */
const de_de2_sharedplan_intro = en_us2_sharedplan_intro;

/** @type {(inputs: Sharedplan_IntroInputs) => LocalizedString} */
const it_it2_sharedplan_intro = en_us2_sharedplan_intro;

/**
* | output |
* | --- |
* | "Nothing changes in your plan until you review it. Importing opens the line-by-line review, where you accept or decline each exercise." |
*
* @param {Sharedplan_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_intro = /** @type {((inputs?: Sharedplan_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_intro(inputs)
	if (locale === "es-419") return es_419_sharedplan_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_intro(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_intro(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_intro(inputs)
	return en_us2_sharedplan_intro(inputs)
});
export { sharedplan_intro as "sharedplan.intro" }